import React, { Fragment, useEffect, useState } from "react";
import { CustomersFileType } from "../Common/Types/types";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import CustomerFilesTreeView from "./TreeView";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";

import { CustomersApi } from "./api";
interface CustomersWidgetProps {
  id: string;
  header: string;
}

const CustomersFilesWidget = (props: CustomersWidgetProps) => {
  const [loading, updateLoading] = useState<boolean>(false);
  const [customerData, updateCustomerData] = useState<CustomersFileType[]>([]);
  const [errorMessage, setErrorMessage] = useState<string>(null);
  const globalParams = useSelector(getParamsSelector);

  useEffect(() => {
    if (globalParams.customerID != null) {
      fetchCustomersRootFolders();
    }
  }, [globalParams.customerID]);
  const fetchCustomersFiles = (item: any): void => {
    updateLoading(true);
    updateCustomerData(null);

    let newParams: any = {};
    newParams.path = item.path;

    CustomersApi.getCustomerFiles(newParams)
      .then((response: any) => {
        if (response != "canceled") {
          processFiles(response, item);
        }
      })
      .catch((error) => {
        if (error.message != "canceled") {
          updateLoading(false);
          setErrorMessage("Oops something went wrong, unable to get data.");
        }
        console.log(error);
      });
  };
  function processFiles(response: any, currentItem: any): void {
    const newData = mapCustomerFiles(response);
    const updatedCustomerData = updateCustomerDataItems(newData, currentItem);
    updateCustomerData(updatedCustomerData);
    updateLoading(false);
    setErrorMessage(null);
  }

  function mapCustomerFiles(files: any) {
    return files.map(({ isFolder, path, url, name }) => ({
      text: name,
      expanded: false,
      isFolder,
      path,
      url,
      name,
    }));
  }

  function updateCustomerDataItems(newItems: any, currentItem: any) {
    let newData: any = [...customerData];
    return newData.map((dataItem) => {
      if (dataItem.text === currentItem.text) {
        return { ...dataItem, items: newItems };
      }
      return dataItem;
    });
  }
  const fetchCustomersRootFolders = (): void => {
    updateLoading(true);
    updateCustomerData(null);
    let newParams: any = { id: globalParams.customerID };

    CustomersApi.getRootFolders(newParams)
      .then((response: any) => {
        if (response != "canceled") {
          const mappedData = response.map((item) => {
            const { isFolder, path, url, name } = item;
            return {
              text: item.name,
              expanded: false,
              isFolder,
              path,
              url,
              name,
              items: [{}],
            };
          });
          updateCustomerData(mappedData);

          updateLoading(false);
          setErrorMessage(null);
        }
      })
      .catch((error) => {
        if (error.message != "canceled") {
          updateLoading(false);
          setErrorMessage("Oops something went wrong, unable to get data.");
        }
        console.log(error);
      });
  };

  if (loading) {
    return <Spinner text="data" />;
  } else if (customerData != null && customerData.length == 0) {
    return (
      <ErrorMessage
        text={"No data found for selected filters."}
        id={props.id}
        header={props.header}
      />
    );
  } else if (errorMessage) {
    return (
      <ErrorMessage text={errorMessage} id={props.id} header={props.header} />
    );
  } else if (customerData != null && customerData.length > 0) {
    return (
      <>
        <CustomerFilesTreeView
          data={customerData}
                itemClick={fetchCustomersFiles}
                source="azure"
        />
      </>
    );
  }
};
export default CustomersFilesWidget;
